import { PhForkKnife, PhStar, PhFile } from '@phosphor-icons/vue'

import { type TemplateOption } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import { type EmailSectionCreate, type CampaignResourceCreate } from '../types'

import { blankTemplate } from './blankTemplate'
import { menuItemTemplate } from './menuItemTemplate'
import { offerTemplate } from './offerTemplate'
const i18n = i18nPlugin.global

const templateOptions: Array<
  TemplateOption<CampaignResourceCreate, EmailSectionCreate>
> = [
  {
    fetchData: menuItemTemplate,
    icon: PhForkKnife,
    requiresLocation: true,
    value: 'menu-item',
  },
  {
    fetchData: offerTemplate,
    icon: PhStar,
    requiresLocation: true,
    value: 'offer',
  },
  {
    fetchData: blankTemplate,
    icon: PhFile,
    value: 'blank',
  },
].map((option) => ({
  ...option,
  label: i18n.t(`email-builder.options.${option.value}`),
}))

export default {
  description: i18n.t('email-builder.description'),
  heading: i18n.t('email-builder.heading'),
  options: templateOptions,
  title: i18n.t('email-builder.title'),
}
